import i18n from '../../i18n';

const INCIDENT_FILTERS = {
  default: [
    {
      id: 'open',
      label: i18n.t('screens.incidents.ongoing'),
      state: 'OP'
    },
    {
      id: 'closed',
      label: i18n.t('screens.incidents.resolved'),
      state: 'CL'
    },
    {
      id: 'all',
      label: i18n.t('screens.incidents.all'),
      state: ''
    }
  ],
  planned: [
    {
      id: 'upcoming',
      label: i18n.t('screens.incidents.labelUpcoming'),
      state: 'PL'
    },
    {
      id: 'ongoing',
      label: i18n.t('screens.incidents.ongoing'),
      state: 'OP'
    },
    {
      id: 'all',
      label: i18n.t('screens.incidents.all'),
      state: ''
    }
  ],
  inctype: [
    {
      id: 'all',
      label: i18n.t('screens.incidents.any')
    },
    {
      id: 'public',
      label: i18n.t('screens.incidents.public')
    },
    {
      id: 'private',
      label: i18n.t('screens.incidents.labelPrivate')
    }
  ]
};

export const INCIDENT_TYPES = {
  public: {
    id: 'public',
    label: i18n.t('screens.incidents.publicIncidents'),
    filter: INCIDENT_FILTERS.default,
    defaultActive: INCIDENT_FILTERS.default[0],
    inctype: INCIDENT_FILTERS.inctype
  },
  planned: {
    id: 'planned',
    label: i18n.t('screens.incidents.scheduledMaintenance'),
    filter: INCIDENT_FILTERS.planned,
    defaultActive: INCIDENT_FILTERS.planned[0],
    inctype: INCIDENT_FILTERS.inctype
  }
};
export const STATUSOPTIONS = [
  {
    id: 'OP',
    icon: 'operational',
    label: i18n.t('screens.incidents.operational')
  },
  {
    id: 'PD',
    icon: 'degraded',
    label: i18n.t('screens.incidents.degradedPerformance')
  },
  {
    id: 'UM',
    icon: 'maintenance',
    label: i18n.t('screens.incidents.underMaintenance')
  },
  {
    id: 'PO',
    icon: 'partial',
    label: i18n.t('screens.incidents.partialOutage')
  },
  {
    id: 'MO',
    icon: 'major',
    label: i18n.t('screens.incidents.majorOutage')
  }
];
export const COMPONENT_STATUSES = {
  OP: 'Operational',
  PD: 'Degraded Performance',
  UM: 'Under Maintenance',
  PO: 'Partial Outage',
  MO: 'Major Outage'
};

export const INCIDENT_STATUSES = {
  OP: 'Ongoing',
  PL: 'Upcoming',
  CL: 'Resolved',
  CN: 'Canceled',
  CL_SM: 'Completed'
};

export const INCIDENT_ACTIONS = {
  resolve: {
    action: 'Resolve',
    action_ing: 'Resolving',
    title: i18n.t('screens.incidents.incidentActions.resolve.title'),
    description: i18n.t(
      'screens.incidents.incidentActions.resolve.description'
    ),
    payload: {
      message: i18n.t('screens.incidents.incidentActions.resolve.message'),
      new_status: 'CL',
      override_affected_component_status_history: true,
      autoupdate_incident_end_time: true
    }
  },
  start: {
    action: 'Start',
    action_ing: 'Starting',
    title: i18n.t('screens.incidents.incidentActions.start.title'),
    description: i18n.t('screens.incidents.incidentActions.start.description'),
    payload: {
      message: i18n.t('screens.incidents.incidentActions.start.message'),
      autoupdate_incident_start_time: 'true',
      new_status: 'OP'
    }
  },
  complete: {
    action: 'Complete',
    action_ing: 'Completing',
    title: i18n.t('screens.incidents.incidentActions.complete.title'),
    description: i18n.t(
      'screens.incidents.incidentActions.complete.description'
    ),
    payload: {
      message: i18n.t('screens.incidents.incidentActions.complete.message'),
      autoupdate_incident_end_time: 'true',
      new_status: 'CL'
    }
  },
  cancel: {
    action: 'Cancel Maintenance',
    action_ing: 'Canceling',
    title: i18n.t('screens.incidents.incidentActions.cancel.title')
  },
  privateincident: {
    action: 'Make it Public',
    action_ing: 'Pending',
    title: i18n.t('screens.incidents.incidentActions.privateincident.title'),
    description: i18n.t(
      'screens.incidents.incidentActions.privateincident.description'
    ),
    additional: i18n.t(
      'screens.incidents.incidentActions.privateincident.additional'
    ),
    message: i18n.t('screens.incidents.incidentActions.privateincident.message')
  },
  privatemaintenance: {
    action: 'Make it Public',
    action_ing: 'Pending',
    title: i18n.t('screens.incidents.incidentActions.privatemaintenance.title'),
    description: i18n.t(
      'screens.incidents.incidentActions.privatemaintenance.description'
    ),
    additional: i18n.t(
      'screens.incidents.incidentActions.privatemaintenance.additional'
    ),
    message: i18n.t(
      'screens.incidents.incidentActions.privatemaintenance.message'
    )
  },
  publicincident: {
    action: i18n.t('screens.incidents.incidentActions.publicincident.action'),
    action_ing: 'Pending',
    title: i18n.t('screens.incidents.incidentActions.publicincident.title'),
    additional: i18n.t(
      'screens.incidents.incidentActions.publicincident.additional'
    ),
    description: i18n.t(
      'screens.incidents.incidentActions.publicincident.description'
    )
  },
  publicmaintenance: {
    action: i18n.t(
      'screens.incidents.incidentActions.publicmaintenance.action'
    ),
    action_ing: 'Pending',
    title: i18n.t('screens.incidents.incidentActions.publicmaintenance.title'),
    additional: i18n.t(
      'screens.incidents.incidentActions.publicmaintenance.additional'
    ),
    description: i18n.t(
      'screens.incidents.incidentActions.publicmaintenance.description'
    )
  }
};

export const INC_TYPE = [
  {
    id: 'public',
    label: i18n.t('screens.incidents.public'),
    icon: 'public-incident'
  },
  {
    id: 'private',
    label: i18n.t('screens.incidents.labelPrivate'),
    icon: 'private-incident'
  }
];
